import { extendObservable } from 'mobx';

class TimeModel {
    constructor(session) {
        this._session = session;
        extendObservable(this, {
            localtime: '',
            ntpserver: '',
            uptime: '',
            errorNetwork: false
        });
    }

    async load() {
        console.log('TimeModel: start');

        try {
            Promise.all([
                this._session.rpc('call', [
                    '',
                    'uci',
                    'get',
                    {
                        config: 'ntp',
                        section: 'source'
                    }
                ]),
                this._session.rpc('call', [
                    '',
                    'barix_webui',
                    'status_get_all',
                    {}
                ])
            ]).then(([settings, settingsUptime]) => {
                if (settings === 500 && settingsUptime === 500) {
                    Object.assign(this, {
                        errorNetwork: true
                    });
                } else {
                    let variable = Object.keys(settings[1].values);
                    let NTPServer = '';

                    for (let i = 0; i < variable.length; i++) {
                        if (variable[i].startsWith('server')) {
                            NTPServer = NTPServer.concat(
                                settings[1].values[variable[i]]
                            );
                            NTPServer = NTPServer.concat('\r\n');
                        }
                    }

                    if (NTPServer === '') {
                        NTPServer = 'No active NTP server found!';
                    }

                    let uptimeValue = this.convertSeconds(
                        settingsUptime[1].uptime
                    );

                    const settingobj = {
                        localtime: '',
                        ntpserver: NTPServer,
                        uptime: uptimeValue
                    };

                    Object.assign(this, settingobj);
                }
            });
        } catch (err) {
            console.error('TimeModel:' + err);
        }

        console.log('TimeModel: end');
    }

    convertSeconds(seconds) {
        let secondsVar = parseInt(seconds, 10);

        const days = Math.floor(secondsVar / (3600 * 24));
        secondsVar -= days * 3600 * 24;
        const hrs = Math.floor(secondsVar / 3600);
        secondsVar -= hrs * 3600;
        const mnts = Math.floor(secondsVar / 60);
        secondsVar -= mnts * 60;
        return (
            days +
            ' days, ' +
            hrs +
            ' hours, ' +
            mnts +
            ' minutes, ' +
            secondsVar +
            ' seconds'
        );
    }
}

export default TimeModel;



// WEBPACK FOOTER //
// ./src/models/TimeModel.js